import styled from "styled-components";

export const IconContainer = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  gap: 1rem;
`;

export const SliderContainer = styled.div`
  padding: 3rem 6rem;
`;

export const Label = styled.div`
  margin-top: 1rem;
  white-space: nowrap;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 3rem;
`;
